import React, { useState } from "react";
import Modal from "react-modal";
import { Col, Form, InputGroup, Button, FormControl } from "react-bootstrap";
import "./add-category-modal.scss";
import Toggle from "react-toggle";

function AddEquipmentCategory({
    openAddCategoryModal,
    close,
    submit,
    errors,
    clearError,
    isEdit,
    editSelectedCat,
}) {
    const [category, setCategory] = useState(
        isEdit ? editSelectedCat.category : "",
    );
    const [category_type, setCategoryType] = useState(
        isEdit ? editSelectedCat.category_type : "terminal",
    );
    const [description, setDescription] = useState(
        isEdit ? editSelectedCat.description : "",
    );
    const [free_text, setFreeText] = useState(
        isEdit ? editSelectedCat.free_text : "",
    );
    const [free_text_enable, setFreeTextEnable] = useState(
        isEdit
            ? editSelectedCat.free_text_enabled == 1
                ? true
                : false
            : false,
    );

    const handleChange = (e) => {
        setCategory(e.target.value);
        clearError();
    };

    const handleChangeRadio = (e) => {
        setCategoryType(e.target.value);
    };

    return (
        <div>
            <Modal
                isOpen={openAddCategoryModal}
                className="add-equipment-category-modal add-template-modal"
            >
                <button className="close-btn" onClick={close}>
                    X
                </button>
                <h2 className="modal-title">
                    {isEdit ? "Update" : "Add"} Equipment Category
                </h2>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        submit(
                            {
                                category,
                                free_text_enable,
                                category_type,
                                description,
                                free_text,
                            },
                            isEdit,
                        );
                    }}
                    id="add-cat-form"
                >
                    <Form.Group as={Col} xs={12} className="px-3">
                        <Form.Control
                            placeholder="Category"
                            type="text"
                            name="category"
                            value={category}
                            onChange={handleChange}
                            className="preapp-form-input"
                        />
                        <label className="modal-lab">Category</label>
                        {errors.category &&
                            errors.category.map((err) => (
                                <Form.Control.Feedback
                                    type="invalid"
                                    className="text-capitalize"
                                >
                                    {" "}
                                    {err}{" "}
                                </Form.Control.Feedback>
                            ))}
                    </Form.Group>

                    <Form.Group as={Col} xs={12} className="px-3">
                        <label className="modal-lab">Category Type</label>
                        <div className="row">
                            <div className="col-md-2 col-sm-2 col-xs-3">
                                <Form.Check
                                    inline
                                    label="Terminal"
                                    value={"terminal"}
                                    checked={category_type == "terminal"}
                                    name="category_type"
                                    type="radio"
                                    onChange={handleChangeRadio}
                                />
                            </div>
                            <div className="col-md-2 col-sm-2 col-xs-3">
                                <Form.Check
                                    inline
                                    label="Gateway"
                                    value="gateway"
                                    name="category_type"
                                    checked={category_type == "gateway"}
                                    type="radio"
                                    onChange={handleChangeRadio}
                                />
                            </div>
                            <div className="col-md-4 col-sm-4 col-xs-4">
                                <Form.Check
                                    inline
                                    label="Add on"
                                    value="add_on"
                                    name="category_type"
                                    checked={category_type == "add_on"}
                                    type="radio"
                                    onChange={handleChangeRadio}
                                />
                            </div>
                        </div>
                        <Form.Control.Feedback
                            type="invalid"
                            className="text-capitalize"
                        >
                            {" "}
                            {errors.description}{" "}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} xs={12} className="px-3">
                        <Form.Control
                            placeholder="Description for category"
                            type="text"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="preapp-form-input"
                        />
                        <label className="modal-lab">Description</label>
                        {errors.description &&
                            errors.description.map((err) => (
                                <Form.Control.Feedback
                                    type="invalid"
                                    className="text-capitalize"
                                >
                                    {" "}
                                    {err}{" "}
                                </Form.Control.Feedback>
                            ))}
                    </Form.Group>

                    <Form.Group as={Col} xs={12} className="px-3">
                        <Form.Control
                            placeholder="Free Text"
                            type="text"
                            name="free_text"
                            value={free_text}
                            onChange={(e) => setFreeText(e.target.value)}
                            className="preapp-form-input"
                        />
                        <label className="modal-lab">Free Text</label>
                        {errors.free_text &&
                            errors.free_text.map((err) => (
                                <Form.Control.Feedback
                                    type="invalid"
                                    className="text-capitalize"
                                >
                                    {" "}
                                    {err}{" "}
                                </Form.Control.Feedback>
                            ))}
                    </Form.Group>

                    <label className="modal-lab">Other: Field enable?</label>
                    <br />
                    <Toggle
                        id="free_text_enable"
                        checked={free_text_enable}
                        name="free_text_enable"
                        onChange={(e) => setFreeTextEnable(e.target.checked)}
                    />

                    <div className="modal-footer">
                        <div className="button-twoc">
                            <button
                                form="add-cat-form"
                                type="submit"
                                className="btn confirm-button"
                            >
                                {" "}
                                {isEdit ? "Update" : "Add"}{" "}
                            </button>
                            <button
                                className="btn cancel-button"
                                onClick={close}
                            >
                                {" "}
                                Cancel{" "}
                            </button>
                        </div>
                    </div>
                </form>
            </Modal>
        </div>
    );
}

export default AddEquipmentCategory;
